import React, { useRef, useState, useEffect } from 'react';
// @ts-ignore
import Slider from 'react-slick';
import styles from './Slider.module.scss';
import { viewStore } from 'stores/ViewStore';

interface Image {
  url: string;
  url_no_params: string;
  width: number;
  height: number;
  srcset: string;
  sizes: string;
}

interface Props {
  images: Image[];
  onSpaceHandler: () => void;
  link: string;
}

const ImageSlider: React.FC<Props> = ({ images, onSpaceHandler, link }) => {
  const [imageWidth, setImageWidth] = useState<number | undefined>(420);
  const [stylesLoaded, setStylesLoaded] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  const {view} = viewStore;

  const handleImageLoad = () => {
    if (containerRef.current) {
      setImageWidth(containerRef.current.offsetWidth);
    }
  };

  const settings = {
    dots: stylesLoaded,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  // only apply if this component is mounted to prevent conflicts
  useEffect(() => {
    const importSlickStyles = async () => {
      await import('slick-carousel/slick/slick.css');
      await import('slick-carousel/slick/slick-theme.css');
      setStylesLoaded(true);
    };

    importSlickStyles();
  }, []);

  return (
    <div ref={containerRef} className={styles.container}>
      <div className={styles.slider_content}>
        <Slider {...settings}>
          {images.map((image, index) => (
            <div key={image.url}>
              <a href={link}>
                <img
                  alt={`slide-${index}`}
                  className={styles.slide}
                  loading='lazy'
                  onLoad={handleImageLoad}
                  onClick={onSpaceHandler}
                  src={`${image.url_no_params}?w=${imageWidth}&h=${view == 'list' ? 280 : 320}&q=90&auto=format,compress&fit=crop&mark=/template/img/wm_icon.png&markscale=5&markalign=center,middle`}
                />
              </a>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default ImageSlider;
